import { Link } from "react-router-dom";
import Photo from "../ui/Photo";
import { useCountUp, useMagnetic, usePointerParallax, useScrollScrub } from "../../lib/motion";
import { toFa } from "../../lib/format";

const STATS = [
  { to: 12, suffix: "", label: "سال تجربه" },
  { to: 800, suffix: "+", label: "عروس" },
  { to: 6, suffix: "", label: "متخصص" },
];

function Stat({ to, suffix, label }) {
  const [ref, value] = useCountUp(to);
  return (
    <div className="hstat" ref={ref}>
      <span className="hstat__n">{toFa(value)}{suffix}</span>
      <span className="hstat__l">{label}</span>
    </div>
  );
}

export default function Hero() {
  const scene = usePointerParallax();
  const bg = useScrollScrub();
  const cta = useMagnetic();

  return (
    <section className="hero" ref={scene}>
      {/* ------------------------------------------- full-bleed backdrop */}
      <div className="hero__bg" ref={bg}>
        <img src={`${process.env.PUBLIC_URL || ""}/images/hero-main.jpg`} alt="" />
        <span className="hero__wash" aria-hidden="true" />
        <span className="hero__grain" aria-hidden="true" />
      </div>

      <div className="wrap wrap--wide hero__inner">
        {/* ------------------------------------------------------- type */}
        <div className="hero__type">
          <span className="hero__kicker">
            <span className="hero__dot" aria-hidden="true" />
            SALON DE BEAUTÉ · TEHRAN
          </span>

          <h1 className="hero__title">
            <span className="reveal-line"><span>زیبایی،</span></span>
            <span className="reveal-line"><span className="hero__em">از نو</span></span>
          </h1>

          <p className="hero__lede">
            مو، پوست، ناخن و آرایش — با متخصصی که کارش را می‌شناسد،
            در فضایی که آرامت می‌کند.
          </p>

          <div className="hero__cta">
            <Link ref={cta} to="/booking" className="btn btn--violet magnetic">
              رزرو نوبت
            </Link>
            <Link to="/services" className="tlink tlink--light">
              مشاهده خدمات<span className="tlink__arrow">←</span>
            </Link>
          </div>

          <div className="hero__stats">
            {STATS.map((s) => <Stat key={s.label} {...s} />)}
          </div>
        </div>

        {/* ---------------------------------------------- floating cards */}
        <div className="hero__cards" aria-hidden="true">
          <div className="hcard hcard--a">
            <Photo src="hero-a" ratio="3 / 4" priority />
            <span className="hcard__tag">پکیج عروس</span>
          </div>

          <div className="hcard hcard--b">
            <Photo src="hero-b" ratio="1 / 1" priority />
            <span className="hcard__tag">اکستنشن مژه</span>
          </div>

          <div className="hcard hcard--chip">
            <span className="hcard__stars">★★★★★</span>
            <span>{toFa("4")}٫{toFa("9")} از {toFa("1240")} نظر</span>
          </div>
        </div>
      </div>

      <div className="hero__foot">
        <div className="wrap wrap--wide hero__footInner">
          <span className="hero__scroll">
            <span className="hero__scrollLine" />
            SCROLL
          </span>
          <span className="hero__note">شنبه تا چهارشنبه · ۹ تا ۲۱</span>
        </div>
      </div>
    </section>
  );
}
